import React from 'react'
import './style.scss'

const RoundedBtn = ({ text, onClick }) => {
    return (
        <button className='roudded__btn' onClick={onClick}>
            {text}
        </button>
    )
}

export default RoundedBtn